import { render, staticRenderFns } from "./whiteNoteReview.vue?vue&type=template&id=92115dd6&scoped=true&"
import script from "./whiteNoteReview.vue?vue&type=script&lang=js&"
export * from "./whiteNoteReview.vue?vue&type=script&lang=js&"
import style0 from "./whiteNoteReview.vue?vue&type=style&index=0&id=92115dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92115dd6",
  null
  
)

export default component.exports